export default "__VITE_ASSET__4a5aaf5b__"